import bhavImage from '../assets/images/kinigroup-bhav-v1.jpeg';
import logoImage from '../assets/images/logo512.png';

const siteContent = {
  brand: {
    name: 'KINI CONSULTING GROUP',
    shortName: 'KINI Consulting Group',
    logo: logoImage
  },
  hero: {
    image: bhavImage,
    title: 'KINI Consulting Group',
    description:
      'We help small businesses create a stronger digital presence, save time on daily operations, and leverage efficient tools to drive growth.',
primaryButton: {
  label: 'Contact Us',
  href: '#contact'
},
    secondaryButton: {
      label: 'Explore Services',
      href: '#services'
    }
  },
  services: [
    {
      title: 'Brand & Identity',
      items: [
        'Custom logo design',
        'Business cards and flyers',
        'Website development',
        'Social media page setup',
        'Ongoing social media support'
      ]
    },
    {
      title: 'Efficiency',
      items: [
        'AI chatbot integration for your website',
        'Automated timekeeping setup',
        'Data entry automation',
        'Internal knowledge documentation and bots for staff',
        'Employee handbook and training materials'
      ]
    },
    {
      title: 'Growth and Intelligence',
      items: [
        'Automated revenue reports',
        'Sales and marketing support',
        'Digital menus and catalogs'
      ]
    }
  ],
  about: {
    title: 'ABOUT',
    paragraphs: [
      'KINI Group was created to help small businesses grow with more clarity, confidence, and ease.',
      'After more than 12 years of building digital products and solving customer problems, I saw that many small business owners were being left out of the kind of support that larger companies often have access to. Branding, websites, automation, and digital tools can make a huge difference, but they often feel too complicated, too expensive, or simply out of reach.',
      'That is why I started KINI Group.',
      'I help small businesses build a stronger presence, improve day-to-day operations, and use practical tools that make work easier. My goal is to create solutions that are simple, useful, and built around real business needs, not unnecessary complexity.',
      'Whether you need help with your brand, your website, customer experience, or systems behind the scenes, I focus on making the process clear and stress-free. Even if you are not technical, you will have support every step of the way.'
    ]
  },
  testimonials: [
    {
      quote:
        'Running a successful bar and restaurant means staying focused on customers and creating a welcoming atmosphere that keeps them coming back. That is what drives revenue. In a fast-moving operation, reporting, expenses, and back-office paperwork can easily fall behind. Bhav brought structure to our finances, kept the numbers organized and accurate, and helped digitize reporting so the business became much easier to manage. His work gave us a clearer picture of the numbers and freed me up to focus on what mattered most: the guest experience.',
      name: 'Karl Jones',
      role: 'Owner and Operator, Legends, Inc.'
    },
    {
      quote:
        'Bhav helped bring more structure and efficiency to our operations at the Fairfield Inn. He improved how we tracked group sales, front desk handoffs, maintenance communication, and room turnover. He also supported design needs and led important workstation and software updates across the property. In addition, he developed a digital version of Schedule A of County Tax that automated parts of our monthly filing process and saved hours of manual work each month. His mix of operational, technical, and design experience made a meaningful difference in how our team works day to day.',
      name: 'Ravi Verma',
      role: 'General Manager, Marriott Fairfield Inn'
    },
    {
      quote:
        'Bhav designed and prepared professional business cards for me on very short notice before an event. The final product looked great, helped me feel more professional, and led to many follow-ups and new clients afterward.',
      name: 'Mamta Desai',
      role: 'Massage Therapist'
    }
  ],
  contact: {
    title: 'CONTACT',
    description:
      'Tell us a little about your business and what kind of support you are looking for.'
  },
  footerLinks: [
    {label: 'Services', href: '#services'},
    {label: 'About', href: '#about'},
    {label: 'Testimonials', href: '#testimonials'},
    {label: 'Contact', href: '#contact'}
  ]
};

export default siteContent;